import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useReducedMotion } from '../../../theme/hooks.js';
import type { AnimatedIconProps } from '../../primitives/types.js';

/** Download — packet drops from top of arrow into the tray.
 *  When `active` is true (e.g. while writing to disk), the tray fills and
 *  flashes, replacing the drip loop to signal completion. */
export function IcnDownload(props: AnimatedIconProps): ReactNode {
  const { active = false, ...rest } = props;
  const reduced = useReducedMotion();
  return (
    <Svg {...rest} iconName="download" data-on={active ? 'true' : 'false'}>
      <path d="M8 3v7" />
      <path d="M5 7.5L8 10.5l3-3" />
      <path d="M3 12h10">
        {active && !reduced && (
          <animate
            attributeName="stroke-width"
            values="1.5;2.4;1.5"
            dur="0.6s"
            repeatCount="indefinite"
          />
        )}
      </path>
      {!active && !reduced && (
        <circle cx="8" cy="4" r="0.9" fill="currentColor" stroke="none" opacity="0">
          <animate
            attributeName="opacity"
            values="0;1;1;0"
            keyTimes="0;0.15;0.85;1"
            dur="1.4s"
            repeatCount="indefinite"
          />
          <animate
            attributeName="cy"
            values="4;10.5;11.8"
            keyTimes="0;0.75;1"
            dur="1.4s"
            repeatCount="indefinite"
          />
          <animate
            attributeName="r"
            values="0.9;0.9;0.2"
            keyTimes="0;0.85;1"
            dur="1.4s"
            repeatCount="indefinite"
          />
        </circle>
      )}
    </Svg>
  );
}
